
import _BaseController from 'Controllers/Web/_BaseController';

export default class extends _BaseController {

    ready() {
        super.ready();
    }
}